import { render } from "./Banners.vue?vue&type=template&id=1c943b71&scoped=true"
import script from "./Banners.vue?vue&type=script&lang=js"
export * from "./Banners.vue?vue&type=script&lang=js"

import "./Banners.vue?vue&type=style&index=0&id=1c943b71&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c943b71"]])

export default __exports__